import { render, staticRenderFns } from "./UserDetailsCard.vue?vue&type=template&id=233749d7&scoped=true&"
import script from "./UserDetailsCard.vue?vue&type=script&lang=js&"
export * from "./UserDetailsCard.vue?vue&type=script&lang=js&"
import style0 from "./UserDetailsCard.vue?vue&type=style&index=0&id=233749d7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "233749d7",
  null
  
)

export default component.exports